/* eslint-disable @typescript-eslint/explicit-function-return-type */

/**
 * To use a beta feature, create a cookie named using the name defined below.
 * The cookie should contain a comma-separated list of allowed beta features (strings).
 */
const BETA_FEATURES_COOKIE_NAME = 'beta_features'

const ALLOWED_BETA_FEATURES = {
  example_beta_feature: true,
} as const

type AllowedBetaFeature = keyof typeof ALLOWED_BETA_FEATURES

type EnabledFeaturesMap = Partial<Record<AllowedBetaFeature, boolean>>
const enabledBetaFeatures: Ref<EnabledFeaturesMap> = ref({})

export const useBetaFeatures = () => {
  const isBetaFeatureEnabled = (betaFeature: AllowedBetaFeature): boolean => {
    return enabledBetaFeatures.value[betaFeature] || false
  }

  return {
    isBetaFeatureEnabled,
  }
}

const checkIsAllowedBetaFeature = (
  feature: string,
): feature is AllowedBetaFeature => {
  const allowedMap: Record<string, boolean> = ALLOWED_BETA_FEATURES
  return Boolean(allowedMap[feature])
}

/**
 * Function to initialize beta features. Should be called once at app start-up.
 */
export const loadBetaFeatures = () => {
  const betaFeaturesCookie = useCookie(BETA_FEATURES_COOKIE_NAME)
  const newEnabledFeaturesMap: EnabledFeaturesMap = {}

  betaFeaturesCookie.value?.split(',').forEach((feature) => {
    if (checkIsAllowedBetaFeature(feature)) {
      newEnabledFeaturesMap[feature] = true
    }
  })
  enabledBetaFeatures.value = newEnabledFeaturesMap
}
